module.exports = __webpack_public_path__ + "static/Image-d01cd6caefa3ffe849170692d99670eb.jpeg";